import { certifiedLabs, HealthChecks, Dental, Vision, DoctorConsultation, PreEmployement, Hra } from '../assets/images'
import { OverviewApi } from '../services'
import moment from 'moment';

const BENEFIT_TYPE_MAP = { 'ahc' : 'health_checks'}


const SERVICE_CARD_DETAILS = {
  'health_checks' : { cardTiles: ['UTILIZATION OF HEALTH CHECKS', 'TOTAL HEALTH CHECKS AVAILED', 'TOTAL VALUE OF HEALTH CHECKS AVAILED'],
                      cardLiners: () => ['Total Sponsored Health checks availed by your employees/ex-employees & their dependents', 'Total value of sponsored health checks availed by employees/ex-employees & their dependents'],
                      btns: [{ text: 'View insights', link: '/test-results' }],
                      viewDetailsLink: '/utilization/ahc',
                      icon: certifiedLabs,
                      donutCardLiner: '*includes only sponsored active employees',
                      requestApi: OverviewApi.fetchHealthChecksOverview
                    },
  'consultations' : { cardTiles: ['UTILIZATION OF DOCTOR CONSULTATION', 'TOTAL CONSULTATIONS TAKEN', 'TOTAL VALUE OF CONSULTATIONS AVAILED'],
                      cardLiners: () => ['Total doctor consultations availed by your employees/ex-employees & their dependents', 'Total value of doctor consultations availed by your employees/ex-employees & their dependents'],
                      viewDetailsLink: '/doctor-consultation',
                      icon: DoctorConsultation,
                      donutCardLiner: '*includes sponsored active employees & their dependents',
                      requestApi: OverviewApi.fetchConsultationsOverview
                    },
  'dental' : { cardTiles: ['UTILIZATION OF DENTAL', 'TOTAL DENTAL CHECKS AVAILED', 'TOTAL VALUE OF DENTAL CHECKS AVAILED'],
               cardLiners: () => ['Total sponsored dental checks availed by your employees/ex-employees & their dependents', 'Total value of sponsored dental checks availed by your employees/ex-employees & their dependents'],
               icon: Dental,
               viewDetailsLink: '/utilization/dental',
               donutCardLiner: '*includes only sponsored active employees',
               requestApi: OverviewApi.fetchDentalOverview
             },
  'vision' : { cardTiles: ['UTILIZATION OF VISION', 'TOTAL VISION CHECKS AVAILED', 'TOTAL VALUE OF VISION CHECKS AVAILED'],
               cardLiners: () => ['Total sponsored vision checks availed by your employees/ex-employees & their dependents', 'Total value of sponsored vision checks availed by your employees/ex-employees & their dependents'],
               icon: Vision,
               viewDetailsLink: '/utilization/vision',
               donutCardLiner: '*includes only sponsored active employees',
               requestApi: OverviewApi.fetchVisionOverview
             },
  'hra' : { cardTiles: ['EMPLOYEES WHO COMPLETED HRA', 'COMPANY WELLNESS SCORE', 'COMPANY WELLNESS GOAL SCORE'],
               cardLiners: (isRunningContract) => [ `Company wellness score for ${isRunningContract ? (moment().format('MMMM')) : 'the contract year'}`, 'Company goal score'],
               btns: [{ text: 'View wellness score', link: '/wellness-score' }, { text: 'View insights', link: '/health-risks' }],
               icon: Hra,
               donutCardLiner: '*includes only active employees',
               requestApi: OverviewApi.fetchHraOverview
              },
  'pre_employment': {
                cardTiles: ['TOTAL ONGOING & COMPLETED CHECKS', 'READY TO BOOK APPOINTMENTS', 'AWAITING APPROVAL'],
                cardLiners: () => ['Ready to book appointments', 'Awaiting approval'],
                btns: [{ text: 'View insights', link: '/pre-employee-checkup' }],
                icon: PreEmployement,
                requestApi: OverviewApi.fetchPreEmploymentOverview
              }
  
}

const BENEFITS = ['ahc', 'consultations', 'dental', 'vision', 'pre_employment']

const NOT_ENABLED_BENEFITS = { 'ahc': { service_type: 'Health checks', icon: HealthChecks, tag: 'health checks' }, 
                               'dental': { service_type: 'Dental', icon: Dental, tag: 'dental checks' },
                               'vision': { service_type: 'Vision', icon: Vision, tag: 'vision checks' },
                               'pre_employment': { service_type: 'Pre employment', icon: PreEmployement, tag: 'pre employment checks' },
                               'consultation24x7': { service_type: 'Doctor consultation', icon: DoctorConsultation, tag: 'doctor consultations' }
                             }
                           
const RELEASE_DATE = '10-05-2024'

let SALES_ROLE = null;

function getRoleFromSessionStorage() {
  return new Promise((resolve) => {
    const role = sessionStorage.getItem('role');
    if (role) {
      resolve(role);
    } else {
      window.addEventListener('roleSet', () => resolve(sessionStorage.getItem('role')));
    }
  });
}

async function main() {
  const role = await getRoleFromSessionStorage();
  SALES_ROLE = role.toLowerCase().replace(/\s/g, '');
  console.log(SALES_ROLE)
}

main();



export { BENEFIT_TYPE_MAP, SERVICE_CARD_DETAILS, BENEFITS, NOT_ENABLED_BENEFITS, RELEASE_DATE, SALES_ROLE }

export const ALL_COUNTRIES_ISD_CODES = [
  { id: '+91', name: '+91 - India' },
  { id: '+60', name: '+60 - Malaysia' },
  { id: '+65', name: '+65 - Singapore' },
  { id: '+63', name: '+63 - Philippines'},
  { id: '+84', name: '+84 - Vietnam' },
  { id: '+976', name: '+976 - Mongolia' },
  { id: '+95', name: '+95 - Myanmar' }
]